import React from 'react';
import Navbar from './Navbar';

const Support = () => {
  return (
    <>
    <Navbar />
    <div>
      <h1>Support Page</h1>
      <p>Get support and help here.</p>
    </div>
    </>
  );
};

export default Support;
